import { AvatarSizeEnum } from '@shared/enums/avatarSize.enum';

export const commonAvatarStyles = {
  fontStyle: 'normal',
  border: 'none',
  textTransform: 'capitalize',
  fontWeight: 400,
  boxSizing: 'border-box !important',
};

export const avatarSizeStyles = {
  [AvatarSizeEnum.size24]: {
    width: AvatarSizeEnum.size24,
    height: AvatarSizeEnum.size24,
    fontSize: 10,
    lineHeight: '16px',
    fontWeight: 400,
    textTransform: 'uppercase',
  },
  [AvatarSizeEnum.size28]: {
    width: AvatarSizeEnum.size28,
    height: AvatarSizeEnum.size28,
    fontSize: 12,
    lineHeight: '16px',
  },
  [AvatarSizeEnum.size32]: {
    width: AvatarSizeEnum.size32,
    height: AvatarSizeEnum.size32,
    fontSize: 14,
    lineHeight: '20px',
  },
  [AvatarSizeEnum.size36]: {
    width: AvatarSizeEnum.size36,
    height: AvatarSizeEnum.size36,
    fontSize: 14,
    lineHeight: '20px',
  },
  [AvatarSizeEnum.size40]: {
    width: AvatarSizeEnum.size40,
    height: AvatarSizeEnum.size40,
    fontSize: 14,
    lineHeight: '20px',
  },
  [AvatarSizeEnum.size44]: {
    width: AvatarSizeEnum.size44,
    height: AvatarSizeEnum.size44,
    fontSize: 17,
    lineHeight: '22px',
  },
  [AvatarSizeEnum.size56]: {
    width: AvatarSizeEnum.size56,
    height: AvatarSizeEnum.size56,
    fontSize: 18,
    fontWeight: '500',
    lineHeight: '22px',
  },
  [AvatarSizeEnum.size64]: {
    width: AvatarSizeEnum.size64,
    height: AvatarSizeEnum.size64,
    fontSize: 17,
    lineHeight: '22px',
  },
  [AvatarSizeEnum.size80]: {
    width: AvatarSizeEnum.size80,
    height: AvatarSizeEnum.size80,
    fontWeight: 500,
    fontSize: 32,
    lineHeight: '42px',
  },
  [AvatarSizeEnum.size96]: {
    width: AvatarSizeEnum.size96,
    height: AvatarSizeEnum.size96,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
  [AvatarSizeEnum.size100]: {
    width: AvatarSizeEnum.size100,
    height: AvatarSizeEnum.size100,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
  [AvatarSizeEnum.size104]: {
    width: AvatarSizeEnum.size104,
    height: AvatarSizeEnum.size104,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
  [AvatarSizeEnum.size120]: {
    width: AvatarSizeEnum.size120,
    height: AvatarSizeEnum.size120,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
  [AvatarSizeEnum.size140]: {
    width: AvatarSizeEnum.size140,
    height: AvatarSizeEnum.size140,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
  [AvatarSizeEnum.size148]: {
    width: AvatarSizeEnum.size148,
    height: AvatarSizeEnum.size148,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
  [AvatarSizeEnum.size172]: {
    width: AvatarSizeEnum.size172,
    height: AvatarSizeEnum.size172,
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '35px',
  },
};
